module.exports = __webpack_public_path__ + "img/2.b9fa7151.jpg";